/** Portal UI version — bump this when the React portal has a major release. */
export const PORTAL_UI_VERSION = 'v3';
